import apiClient from './apiClient';

export const getLotteries = () => apiClient.get('/lottery_category');
export const createLottery = (data) => apiClient.post('/lottery_category', data);
export const updateLottery = (data) => apiClient.put(`/lottery_category/${data.id}`, data);
export const deleteLottery = (id) => apiClient.delete(`/lottery_category/${id}`);
